<template>
  <section id="view-case-screen">
    <span data-v-162fe0fb="" class="case-creation__divider"></span>
    <div v-if="archiveInsuranceLoading" class="loading-message">
      Loading archived insurances...
    </div>
    <div v-else class="case-creation__step case-creation__Case-information">
      <div class="case-creation__card"  >
        <div class="case-creation__heading">
          <div class="title-with-icon">
            <!-- <span class="icon">
              <img
                src="@/assets/images/icons/icon-billing-info.svg"
                alt="icon"
                class="img-fluid"
              />
            </span> -->
            <h3 class="title">Archived / Inactive Insurance Details</h3>
          </div>
        </div>

        <div class="case-creation__body" >
          <div
            class="vue-data archived-insurance-details-block"
            v-if="inactiveInsuranceData.length"
          >
            <div
              class="each-block"
              v-for="(data, index) in inactiveInsuranceData"
              :key="index"
            >
              <!-- Optional Section Title -->
              <h4 v-if="data.insurance_type">
                {{ data.insurance_type.toUpperCase() }} Insurance
              </h4>
              <el-row :gutter="20">
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Relationship</h4>
                    <p class="value">{{ data.relationship ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Plan Type</h4>
                    <p class="value">{{ data.plan_type ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">First Name</h4>
                    <p class="value">{{ data.first_name ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Middle Name</h4>
                    <p class="value">{{ data.middle_name ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Last Name</h4>
                    <p class="value">{{ data.last_name ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Gender</h4>
                    <p class="value">{{ data.gender ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Date of Birth</h4>
                    <p class="value">
                      {{ formatDate(data.date_of_birth) ?? "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Insurance Name</h4>
                    <p class="value">{{ data.insurance_name ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Insurance Carrier Code</h4>
                    <p class="value">
                      {{ data.insurance_carrier_code ?? "--" }}
                    </p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Policy No</h4>
                    <p class="value">{{ data.policy_id ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Group#</h4>
                    <p class="value">{{ data.group ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 1</h4>
                    <p class="value">{{ data.address_line_1 ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Address Line 2</h4>
                    <p class="value">{{ data.address_line_2 ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Zip</h4>
                    <p class="value">{{ data.zip ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">State</h4>
                    <p class="value">{{ data.state ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">City</h4>
                    <p class="value">{{ data.city ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Plan Name</h4>
                    <p class="value">{{ data.plan_name ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Effective Date</h4>
                    <p class="value">{{ data.effective_date ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Termination Date</h4>
                    <p class="value">{{ data.termination_date ?? "--" }}</p>
                  </div>
                </el-col>

                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Total Individual Deductible Amount</h4>
                    <p class="value">{{ data.individual_deductible ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Total Individual Deductible Remaining</h4>
                    <p class="value">{{ data.individual_deductible_remaining ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Group Number</h4>
                    <p class="value">{{ data.group_number ?? "--" }}</p>
                  </div>
                </el-col>
                <el-col :xl="3" :lg="4" :md="8" :sm="12" :xs="12">
                  <div class="input-value view-cases">
                    <h4 class="name">Group Name</h4>
                    <p class="value">{{ data.group_name ?? "--" }}</p>
                  </div>
                </el-col>
              </el-row>
              <div></div>
            </div>
          </div>
          <div v-else class="no-records-message">
            <p>No Archived Insurances Found</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { onMounted, computed } from "vue";
import moment from "moment";

const props = defineProps({
  inactiveInsuranceData: {
    type: Array,
    required: true,
  },
  archiveInsuranceLoading: {
    type: Boolean,
    required: true,
  },
});

const formatDate = (date) => {
  return date ? moment(date).format("MM-DD-YYYY") : "--";
};

// Sort by date if available

onMounted(() => {
  console.log("Inactive Insurance Data:", props.inactiveInsuranceData);
});
</script>

<style scoped lang="scss">
.archived-insurance-details-block {
  max-height: 500px;
  overflow-y: auto;
  .each-block {
    margin-bottom: 1rem;
    border: 1px solid #dcdcdc;
    border-radius: 15px;
    padding: 10px;
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
</style>
